//to check if input is empty
export function isEmpty(str) {
    if(!str && str.length === 0) {
        return true
    }
    else{
        //console.log('false');
    } 
}
//to check if email is valid
export function isValidEmail(str) {
    const pattern = '[a-zA-Z0-9._-]+@[a-z]+\\.+[a-z]+';
    var re = new RegExp(pattern);
    if(re.test(str)) {
        return 'Valid Email'
    }
    else {
        return 'Invalid Email'
    }
}
//to check if number is valid
export function isValidNumber(str) {
    //console.log(str)
    const pattern = '^[0-9]+$';
    var re = new RegExp(pattern);
    if(re.test(str)) {
        return 'Valid number'
    }
    else {return 'Invalid number'}
}
//to check if password is valid
export function isValidPassword(str) {
    const pattern = '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=\\S+$).{4,}$';
    var re = new RegExp(pattern);
    if(re.test(str)) {
        return'Valid password'
    }
    else { return 'InValid Password'}
}

export function isValidString(str) {
    // const pattern = '^(?:[a-zA-Z0-9_]+)?$';
    // var re = new RegExp(pattern);
    // if(re.test(str)) {
    //     return'Valid String'
    // }
    // else { return 'InValid String'}

        if(!((str.keyCode >= 65) && (str.keyCode <= 90) || (str.keyCode >= 97) && (str.keyCode <= 122) || (str.keyCode >= 48) && (str.keyCode <= 57))){
            str.returnValue = false;
           return;
        }
        str.returnValue = true;
}

export function getSQLDate(date) {
  if(date){
    let yyyy = date.getFullYear().toString();
    let mm = (date.getMonth()+1).toString();
    let dd  = date.getDate().toString();

    let mmChars = mm.split('');
    let ddChars = dd.split('');

    return yyyy + '-' + (mmChars[1]?mm:"0"+mmChars[0]) + '-' + (ddChars[1]?dd:"0"+ddChars[0]);
  }else{
      return ''
  }
}
//const validation = { isEmpty: true, isValidEmail: true};
// export { isEmpty, isValidEmail, isValidNumber, isValidPassword, getSQLDate};